import { Component, Input, OnInit } from '@angular/core';
import { PopoverController } from '@ionic/angular';
import { DialogService } from '../../_services/dialog.service';
import { Config } from '../../_store/config';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'enter-pin-form',
  templateUrl: './enter-pin-form.component.html',
  styleUrls: ['./enter-pin-form.component.scss'],
})
export class EnterPinFormComponent implements OnInit {
  @Input() options: any = {}
  formSubmitted = false;
  loading = false;
  minPinLength = Config.min_pin_length;
  maxPinLength = Config.max_pin_length;
  CONFIRM_APPROVAL = this.translate.instant('LABELS.CONFIRM_APPROVAL');
  CONFIRM_REJECTION = this.translate.instant('LABELS.CONFIRM_REJECTION')
  constructor(
    private modal: PopoverController,
    private translate : TranslateService
  ) { }

  ngOnInit() {
    // console.log(this.options);
  }

  close(returnVal = false) {
    try {
      this.modal.dismiss(returnVal);
    } catch (error) {
      console.log("error : ", error);      
    }
  }

  onPinEntered() {
    this.close(true);
  }

}
